import { render, staticRenderFns } from "./ConnectionMonitor.vue?vue&type=template&id=380d9bd2&scoped=true&"
import script from "./ConnectionMonitor.vue?vue&type=script&lang=js&"
export * from "./ConnectionMonitor.vue?vue&type=script&lang=js&"
import style0 from "./ConnectionMonitor.vue?vue&type=style&index=0&id=380d9bd2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "380d9bd2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/atlassian/pipelines/agent/build/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('380d9bd2')) {
      api.createRecord('380d9bd2', component.options)
    } else {
      api.reload('380d9bd2', component.options)
    }
    module.hot.accept("./ConnectionMonitor.vue?vue&type=template&id=380d9bd2&scoped=true&", function () {
      api.rerender('380d9bd2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ConnectionMonitor.vue"
export default component.exports